<template>
  <span>
    <i v-if="!isDisabled" class="fa fa-trash fa-danger" @click="onShowModal"/>
    <i v-else class="fa fa-trash fa-secondary-disabled"/>

    <Modal ref="delete-order-attachment"
      @onClose="closeModal"
      :values="deleteModalValues">
      <template slot="footer">
        <b-button variant="danger" data-dismiss="modal" :disabled="spinners.isDeleting" @click='deleteAttachment()'>
          <b-spinner v-if="spinners.isDeleting" type="grow" small/>
          {{ 'delete' | translate('global') }}
        </b-button>
        <b-button variant="secondary" @click="closeModal()" class="ml-2">
          {{ 'cancel' | translate('global') }}
        </b-button>
      </template>
    </Modal>
  </span>
</template>

<script>
import Modal from '@/views/sharedComponents/Modal';
import statuses from '@/store/statuses';
import { mapActions, mapGetters } from 'vuex';
import VuexTypes from '@/store/types/index';

const OrdersTypes = VuexTypes.orders;
export default {
  props: ['id', 'isDisabled'],
  data() {
    return {
      spinners: {
        isDeleting: false
      },
      deleteModalValues: {
        id: 'delete-order-attachment',
        title: this.$t('are_you_sure', 'global'),
        body: this.$t('delete_order_attachment_confirm_text', 'global'),
      },
    };
  },
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('Orders', [
      'orderDeleteAttachment',
    ]),
  },
  watch: {
    orderDeleteAttachment: {
      handler: function () {
        this.spinners.isDeleting = false;
        if (this.orderDeleteAttachment.status === statuses.LOADED) {
          this.closeModal();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Orders', [
      OrdersTypes.ORDER_DELETE_ATTACHMENT,
    ]),
    deleteAttachment() {
      this.spinners.isDeleting = true;
      this.ORDER_DELETE_ATTACHMENT({
        orderId: this.$route.params.id,
        attachmentId: this.id
      });
    },
    onShowModal() {
      this.$refs['delete-order-attachment'].show();
    },
    closeModal() {
      this.$refs['delete-order-attachment'].hide();
    },
  }
};
</script>
